export default [
  {
    path: 'tickets',
    name: 'admin/tickets',
    component: () => import('@/views/admin/Tickets.vue'),
    meta: { title: '工单管理' },
  },
  {
    path: 'tickets/:ticketNo',
    name: 'admin/ticketMessages',
    component: () => import('@/views/admin/TicketMessages.vue'),
    meta: { title: '工单详情' },
  },
  {
    path: 'invoices',
    name: 'admin/invoices',
    component: () => import('@/views/admin/Invoices.vue'),
    meta: { title: '发票管理' },
  },
  {
    path: 'serviceCodes',
    name: 'admin/serviceCodes',
    component: () => import('@/views/admin/ServiceCodes.vue'),
    meta: { title: '服务码管理' },
  },
  {
    path: 'nodes',
    name: 'admin/nodes',
    component: () => import('@/views/admin/Nodes.vue'),
    meta: { title: '服务器管理' },
  },
  {
    path: 'hosts',
    name: 'admin/hosts',
    component: () => import('@/views/admin/Hosts.vue'),
    meta: { title: '网站云管理' },
  },
  {
    path: 'clouds',
    name: 'admin/clouds',
    component: () => import('@/views/admin/Clouds.vue'),
    meta: { title: '云助手管理' },
  },
  {
    path: 'images',
    name: 'admin/images',
    component: () => import('@/views/admin/Images.vue'),
    meta: { title: '免版权图库管理' },
  },
  {
    path: 'contacts',
    name: 'admin/contacts',
    component: () => import('@/views/admin/Contacts.vue'),
    meta: { title: '咨询管理' },
  },
  {
    path: 'users',
    name: 'admin/users',
    component: () => import('@/views/admin/Users.vue'),
    meta: { title: '用户管理' },
  },
  {
    path: 'orders',
    name: 'admin/orders',
    component: () => import('@/views/admin/Orders.vue'),
    meta: { title: '订单管理' },
  },
  {
    path: 'v7',
    name: 'admin/v7',
    component: () => import('@/views/admin/V7.vue'),
    meta: { title: 'V7 版本管理' },
  },
  {
    path: 'v6',
    name: 'admin/v6',
    component: () => import('@/views/admin/V6.vue'),
    meta: { title: 'V6 版本管理' },
  },
  {
    path: 'tags',
    name: 'admin/tags',
    component: () => import('@/views/admin/Tags.vue'),
    meta: { title: '标签管理' },
  },
  {
    path: 'extensions',
    name: 'admin/extensions',
    component: () => import('@/views/admin/Extensions.vue'),
    meta: { title: '插件管理' },
  },
  {
    path: 'themes',
    name: 'admin/themes',
    component: () => import('@/views/admin/Themes.vue'),
    meta: { title: '模板管理' },
  },
  {
    path: 'backups',
    name: 'admin/backups',
    component: () => import('@/views/admin/Backups.vue'),
    meta: { title: '备份管理' },
  },
  {
    path: 'healths',
    name: 'admin/healths',
    component: () => import('@/views/admin/Healths.vue'),
    meta: { title: '健康检查' },
  },
  {
    path: 'logsError',
    name: 'admin/logsError',
    component: () => import('@/views/admin/LogsError.vue'),
    meta: { title: '系统错误' },
  },
  {
    path: 'utilities',
    name: 'admin/utilities',
    component: () => import('@/views/admin/Utilities.vue'),
    meta: { title: 'Utilities' },
  },
];
